import { ChangeEvent, useRef, useState } from "react";
import useOnClickOutside from "../../utils/hooks/useOnClickOutside";
import { Icon } from "../Icon";
import "./styles.scss";
import Label from "../Label";
import Button from "../common/Button";
import classNames from "classnames";

interface MultiSelectProps {
  options: MultiSelectOption[];
  title: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  selectedOptions: MultiSelectOption[];
  buttonLabel?: string;
  buttonAction?: () => void;
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  buttonLabel,
  buttonAction,
  options,
  selectedOptions,
  title,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const multiSelectRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(multiSelectRef, () => setIsOpen(false));
  const displayCounter =
    selectedOptions.length > 0 &&
    selectedOptions.some((option) => option.value === "all") === false;

  const hasCtaButton = buttonLabel && buttonAction;
  return (
    <section className="multi-select" ref={multiSelectRef}>
      <div
        className="multi-select__button"
        onClick={() => setIsOpen((prevIsOpen) => !prevIsOpen)}
      >
        <p className="multi-select__title">{title}</p>
        {displayCounter && (
          <p className="multi-select__count"> {selectedOptions.length}</p>
        )}
        <Icon
          iconName={isOpen ? "up_arrow" : "down_arrow"}
          className="multi-select__arrow"
        />
      </div>
      {isOpen && (
        <div className="multi-select__options">
          <div className={"multi-select__options-container"}>
            {options.map((option, index) => (
              <div className="multi-select__option--container" key={index}>
                <input
                  id={option.value}
                  className="multi-select__checkbox"
                  type="checkbox"
                  value={option.value}
                  onChange={onChange}
                  checked={selectedOptions.some(
                    (o) => o.value === option.value
                  )}
                />
                <label
                  key={option.value}
                  className="multi-select__option"
                  htmlFor={option.value}
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
          {hasCtaButton ? (
            <div className="multi-select__cta-container">
              <Button
                disabled={selectedOptions.length === 0}
                modifier="primary"
                onClick={buttonAction}
                className={"multi-select__cta-button"}
              >
                {buttonLabel}
              </Button>
            </div>
          ) : null}
        </div>
      )}
    </section>
  );
};

export default MultiSelect;
